import ApiItemTypeEnum from './ApiItemTypeEnum';
import InitialData from './InitialData';
import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';

export default function getInitialMessageComposeData(
    adapter: MessageComposeAdapter,
    data: InitialData
): InitialData {
    data.itemType = ApiItemTypeEnum.MessageCompose;
    data.conversationId = adapter.getConversationId();
    data.isRead = false;
    return data;
}
